<!-- =========================================================================================
    File Name: VxCard.vue
    Description: Card Component
    Component Name: VxCard
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>
        <div v-if="gallery3">
            <div
                class="vx-card"
                ref="card"
                :class="[
                    {'overflow-hidden': tempHidden},
                    {'no-shadow': noShadow},
                    {'rounded-none': noRadius},
                    {'card-border': cardBorder},
                    cardClasses
                ]"
                :style="cardStyles"
                v-if="image === false"
            >
                <div class="vx-card__header" v-if="hasHeader">

                    <!-- card title -->
                    <div class="vx-card__title">
                        <h4 v-if="this.$props.title" :style="titleStyles" :class="titleClasses">{{ title }}</h4>
                        <h4 v-if="this.$props.subtitle" style="color: #2c2c2c !important; font-weight: 500;"
                            :class="subtitleClasses">
                            {{ subtitle }}</h4>
                    </div>

                    <!-- card actions -->
                    <div class="vx-card__actions" v-if="hasAction">
                        <slot name="actions">
                            <div class="vx-card__action-buttons"
                                 v-if="(actionButtons || collapseAction || refreshContentAction || removeCardAction) && !codeToggler">
                                <feather-icon @click="toggleContent" icon="ChevronUpIcon"
                                              :class="{rotate180: !isContentCollapsed}"
                                              class="ml-4" v-if="actionButtons || collapseAction"/>
                                <feather-icon @click="refreshcard" icon="RotateCwIcon" class="ml-4"
                                              v-if="actionButtons || refreshContentAction"/>
                                <feather-icon @click="removeCard" icon="XIcon" class="ml-4"
                                              v-if="actionButtons || removeCardAction"/>
                            </div>
                            <div class="vx-card__code-toggler sm:block hidden" v-if="codeToggler && !actionButtons">
                                <feather-icon icon="CodeIcon"
                                              :class="{'border border-solid border-primary border-t-0 border-r-0 border-l-0': showCode}"
                                              @click="toggleCode"></feather-icon>
                            </div>
                        </slot>
                    </div>
                </div>

                <div class="vx-card__collapsible-content vs-con-loading__container" ref="content"
                     :class="[{collapsed: isContentCollapsed}, {'overflow-hidden': tempHidden}]" :style="StyleItems">

                    <!-- content with no body(no padding) -->
                    <slot name="no-body"></slot>

                    <!-- content inside body(with padding) -->
                    <div class="vx-card__body" v-if="this.$slots.default">
                        <slot></slot>
                    </div>

                    <!-- content with no body(no padding) -->
                    <slot name="no-body-bottom"></slot>

                    <div class="vx-card__footer" v-if="this.$slots.footer">
                        <slot name="footer"></slot>
                    </div>
                </div>

                <div class="vx-card__code-container" ref="codeContainer" v-show="this.$slots.codeContainer"
                     :style="codeContainerStyles" :class="{collapsed: !showCode}">
                    <div class="code-content">
                        <prism :language="codeLanguage">
                            <slot name="codeContainer"></slot>
                        </prism>
                    </div>
                </div>
            </div>
            <div v-if="image">
                <div class="flex flex-bg">
                    <div class="w-6/12" style="display: flex;justify-content: center;align-items: center;">
                        <img :src="gallery2">
                    </div>
                    <div class="w-6/12">
                        <h4 v-if="this.$props.title" :style="titleStyles" :class="titleClasses" class="mb-5">{{
                                title
                            }}</h4>
                        <p v-if="this.$props.description">{{ description }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="wish_list">
            <div
                class="vx-card"
                ref="card"
                :class="[
                    {'overflow-hidden': tempHidden},
                    {'no-shadow': noShadow},
                    {'rounded-none': noRadius},
                    {'card-border': cardBorder},
                    cardClasses
                ]"
                :style="cardStyles"
                v-if="image === false"
            >
                <div class="vx-card__header" v-if="hasHeader">

                    <!-- card title -->
                    <div class="vx-card__title">
                        <h4 v-if="this.$props.title" :style="titleStyles" :class="titleClasses">{{ title }}</h4>
                        <h4 v-if="this.$props.subtitle" style="color: #2c2c2c !important; font-weight: 500;"
                            :class="subtitleClasses">
                            {{ subtitle }}</h4>
                    </div>

                    <!-- card actions -->
                </div>

                <div class="vx-card__collapsible-content vs-con-loading__container" ref="content"
                     :class="[{collapsed: isContentCollapsed}, {'overflow-hidden': tempHidden}]" :style="StyleItems">

                    <!-- content with no body(no padding) -->
                    <slot name="no-body"></slot>

                    <!-- content inside body(with padding) -->
                    <div class="vx-card__body" v-if="this.$slots.default">
                        <slot></slot>
                    </div>

                    <!-- content with no body(no padding) -->
                    <slot name="no-body-bottom"></slot>

                    <div class="vx-card__footer" v-if="this.$slots.footer">
                        <slot name="footer"></slot>
                    </div>
                </div>

                <div class="vx-card__code-container" ref="codeContainer" v-show="this.$slots.codeContainer"
                     :style="codeContainerStyles" :class="{collapsed: !showCode}">
                    <div class="code-content">
                        <prism :language="codeLanguage">
                            <slot name="codeContainer"></slot>
                        </prism>
                    </div>
                </div>
            </div>
            <div v-if="image">
                <div class="flex flex-bg">
                    <div class="w-6/12" style="display: flex;justify-content: center;align-items: center;">
                        <img :src="gallery2">
                    </div>
                    <div class="w-6/12">
                        <h4 v-if="this.$props.title" :style="titleStyles" :class="titleClasses" class="mb-5">{{
                                title
                            }}</h4>
                        <p v-if="this.$props.description">{{ description }}</p>
                        <p v-if="this.$props.description">{{ description }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="product_top">
            <div>
                <div class="vx-row flex-bg" style="padding: 0;margin: 0">
                    <div v-if="image" class="vx-col sm:w-3/12 w-full"
                         style="justify-content: center;align-items: center;padding: 1.5rem 0.75rem 1.5rem 1.5rem;">
                        <img :src="image" style="width: 100%">
                    </div>
                    <div class="vx-col w-full" :class="[{'sm:w-9/12': image}, {'sm:w-12/12': !image}]" style="padding: 1.5rem 1.5rem 1.5rem 0.75rem;">
                        <h4 v-if="product.FullTitle" :style="titleStyles" :class="titleClasses" class="mb-5">
                            {{ product.FullTitle }}
                        </h4>

                        <p v-if="product.provider_id === 3">
                            <template v-if="adobe.sendData.customer_id != 0 && allSegmentProducts[adobe.customers.find((customer) => { return customer.id == adobe.sendData.customer_id }).customer.companyProfile.marketSegment] !== undefined">
                                {{ allSegmentProducts[adobe.customers.find((customer) => { return customer.id == adobe.sendData.customer_id }).customer.companyProfile.marketSegment].Description }}
                            </template>
                        </p>
                        <p v-else-if="product.Description">{{ product.Description }}</p>

                        <template v-if="product.provider_id === 3 && userInfo.type_id === 3">
                            <div class="py-4">
                                <div class="vx-row">
                                    <div class="vx-col sm:w-1/3 w-full">
                                        <span>{{ $t('AdobeCustomer') }} *</span>
                                        <div class="con-select w-full select-large">
                                            <div class="input-select-con">
                                                <vs-select v-model="adobe.sendData.customer_id" autocomplete class="w-full select-large">
                                                    <vs-select-item :key="index" :value="item.id" :text="item.customer.customerId+' - '+item.company_name" v-for="(item,index) in adobe.customers" class="w-full" />
                                                </vs-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vx-col sm:w-1/3 w-full">
                                        <div class="">{{ $t('quantity') }} *</div>
                                        <div
                                             class="vs-input-number inline-flex vs-input-number-size-null vs-input-number-primary"
                                             style="margin: 8px 0 0;">
                                            <button type="button" class="btn-less vs-input-number--button-less limit" ref="btnLess"
                                                    @click="minus()">
                                                <i class="vs-icon notranslate icon-scale material-icons null">remove</i>
                                            </button>
                                            <input type="number" :value="quantity" v-on:keyup="changeQuantity" class="vs-input-number--input" style="width: 9.1px;" ref="quantityInput">
                                            <button type="button" class="btn-plus vs-input-number--button-plus" @click="plus()">
                                                <i class="vs-icon notranslate icon-scale material-icons null">add</i>
                                            </button>
                                        </div>
                                        <vs-checkbox class="inline-flex" :disabled="adobe.sendData.quantity < 10" v-model="adobe.sendData.treeYearCommitment" style="position: relative; top: 3px; margin-left: 20px;">&nbsp;3 Year Commit Option</vs-checkbox>
                                    </div>
                                </div>
                            </div>
                            <div class="pb-4" v-if="adobe.calculatedData">
                                <table>
                                    <tr>
                                        <td>{{ $t('title') }}</td>
                                        <td width="16" align="center">:</td>
                                        <td>{{ adobe.calculatedData.FullTitle }}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('SKU') }}</td>
                                        <td align="center">:</td>
                                        <td>{{ adobe.calculatedData.Sku }}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('pricePerOne') }}</td>
                                        <td align="center">:</td>
                                        <td>${{ adobe.calculatedData.Amount }} ({{ $t('for_x_days', {days: adobe.calculatedData.days}) }})</td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('totalPrice') }}</td>
                                        <td align="center">:</td>
                                        <td>${{ adobe.calculatedData.total }}</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="pb-4">
                                <div class="vx-row">
                                    <div class="vx-col sm:w-1/3 w-full">
                                        <vs-button v-if="adobe.calculatedData" icon-pack="feather" icon="icon-shopping-bag" class="text-sm font-semibold vs-button-success" @click="addToBasketAdobeProduct()">{{ $t('addToCart') }}</vs-button>
                                        <vs-button v-else icon-pack="feather" icon="icon-dollar-sign" class="text-sm font-semibold" :disabled="adobe.sendData.customer_id == 0" @click="getProductPrice()">{{ $t('getPrice') }}</vs-button>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <p v-if="userInfo.type_id === 3 || userInfo.type_id === 4" class="mt-4 font-bold text-sm">
                                {{ $t('quantity') }}<span v-if="checkout">: {{ quantity }}</span>
                            </p>
                            <div v-if="!checkout && (userInfo.type_id === 3 || userInfo.type_id === 4)"
                                 class="vs-input-number inline-flex vs-input-number-size-null vs-input-number-primary"
                                 style="margin: 5px 0px 0px;">
                                <button type="button" class="btn-less vs-input-number--button-less limit" ref="btnLess"
                                        @click="minus()">
                                    <i class="vs-icon notranslate icon-scale material-icons null">remove</i>
                                </button>
                                <input type="number" :value="quantity" v-on:keyup="changeQuantity" class="vs-input-number--input" style="width: 9.1px;" ref="quantityInput">
                                <button type="button" class="btn-plus vs-input-number--button-plus" @click="plus()">
                                    <i class="vs-icon notranslate icon-scale material-icons null">add</i>
                                </button>
                            </div>

                            <h5 v-if="!userInfo.need_azn_cash" class="font-bold text-center">${{ parseFloat(showAmount) }}</h5>
                            <div v-else class="mt-2 mb-2">
                                <div v-if="checkout">
                                    <h5 v-if="userInfo.need_azn_cash" class="font-bold">{{ $t('cash') }}:
                                        {{ parseFloat(showAmountCash) }} AZN</h5>
                                    <h5 v-if="userInfo.need_azn_credit" class="font-bold">{{ $t('credit') }}:
                                        {{ parseFloat(showAmountCredit) }} AZN</h5>
                                </div>
                                <div v-else>
                                    <h5 v-if="userInfo.need_azn_cash" class="font-bold">
                                        <vs-radio v-model="sell_type" :vs-value="1" :vs-name="'radio_'+product.id">
                                            {{ $t('cash') }}: {{ parseFloat(showAmountCash) }} AZN
                                        </vs-radio>
                                    </h5>
                                    <h5 v-if="userInfo.need_azn_credit" class="font-bold">
                                        <vs-radio v-model="sell_type" :vs-value="2" :vs-name="'radio_'+product.id">
                                            {{ $t('credit') }}: {{ parseFloat(showAmountCredit) }} AZN
                                        </vs-radio>
                                    </h5>
                                </div>
                            </div>


                            <vs-button v-if="!checkout && (userInfo.type_id === 3 || userInfo.type_id === 4)"
                                       icon-pack="feather" icon="icon-shopping-bag" class="text-sm font-semibold"
                                       @click="addToBasket()">{{ $t('addToCart') }}
                            </vs-button>
                            <vs-button v-else-if="checkout && (userInfo.type_id === 3 || userInfo.type_id === 4)"
                                       icon-pack="feather" icon="icon-x" color="rgb(246, 246, 246)" type="filled"
                                       class="text-sm text-dark font-semibold" @click="removeItemFromBasket(item)">
                                {{ $t('remove') }}
                            </vs-button>
                        </template>

                        <div class="mt-3 text-sm" v-if="userInfo.type_id === 3 || userInfo.type_id === 4"
                             :class="!product.is_returnable ? 'text-danger font-semibold' : 'font-light'">
                            {{ $t('note') }}: {{ product.is_returnable ? $t('returnable') : $t('not_returnable') }}
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="vx-card" ref="card" :class="[
        {'overflow-hidden': tempHidden},
        {'no-shadow': noShadow},
        {'rounded-none': noRadius},
        {'card-border': cardBorder},
        cardClasses ]" :style="cardStyles" v-if="image === false">
                <div class="vx-card__header" v-if="hasHeader">

                    <!-- card title -->
                    <div class="vx-card__title">
                        <h4 v-if="this.$props.title" :style="titleStyles" :class="titleClasses">{{ title }}</h4>
                        <h4 v-if="this.$props.subtitle" style="color: #2c2c2c !important; font-weight: 500;"
                            :class="subtitleClasses">
                            {{ subtitle }}</h4>
                    </div>

                    <!-- card actions -->
                    <div class="vx-card__actions" v-if="hasAction">
                        <slot name="actions">
                            <div class="vx-card__action-buttons"
                                 v-if="(actionButtons || collapseAction || refreshContentAction || removeCardAction) && !codeToggler">
                                <feather-icon @click="toggleContent" icon="ChevronUpIcon"
                                              :class="{rotate180: !isContentCollapsed}"
                                              class="ml-4" v-if="actionButtons || collapseAction"/>
                                <feather-icon @click="refreshcard" icon="RotateCwIcon" class="ml-4"
                                              v-if="actionButtons || refreshContentAction"/>
                                <feather-icon @click="removeCard" icon="XIcon" class="ml-4"
                                              v-if="actionButtons || removeCardAction"/>
                            </div>
                            <div class="vx-card__code-toggler sm:block hidden" v-if="codeToggler && !actionButtons">
                                <feather-icon icon="CodeIcon"
                                              :class="{'border border-solid border-primary border-t-0 border-r-0 border-l-0': showCode}"
                                              @click="toggleCode"></feather-icon>
                            </div>
                        </slot>
                    </div>
                </div>

                <div class="vx-card__collapsible-content vs-con-loading__container" ref="content"
                     :class="[{collapsed: isContentCollapsed}, {'overflow-hidden': tempHidden}]" :style="StyleItems">

                    <!-- content with no body(no padding) -->
                    <slot name="no-body"></slot>

                    <!-- content inside body(with padding) -->
                    <div class="vx-card__body" v-if="this.$slots.default">
                        <slot></slot>
                    </div>

                    <!-- content with no body(no padding) -->
                    <slot name="no-body-bottom"></slot>

                    <div class="vx-card__footer" v-if="this.$slots.footer">
                        <slot name="footer"></slot>
                    </div>
                </div>

                <div class="vx-card__code-container" ref="codeContainer" v-show="this.$slots.codeContainer"
                     :style="codeContainerStyles" :class="{collapsed: !showCode}">
                    <div class="code-content">
                        <prism :language="codeLanguage">
                            <slot name="codeContainer"></slot>
                        </prism>
                    </div>
                </div>
            </div>
            <div v-if="image">
                <div class="flex flex-bg">
                    <div class="w-6/12" style="display: flex;justify-content: center;align-items: center;">
                        <img :src="gallery2">
                    </div>
                    <div class="w-6/12">
                        <h4 v-if="this.$props.title" :style="titleStyles" :class="titleClasses" class="mb-5">{{
                                title
                            }}</h4>
                        <p v-if="this.$props.description">{{ description }}</p>
                        <p v-if="this.$props.description">{{ description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Prism from 'vue-prism-component'
import _color from '@/assets/utils/color.js'

export default {
    name: 'vx-card',
    props: {
        product: {
            type: Object,
            required: false,
            default: null
        },
        allSegmentProducts: {
            type: Object,
            required: false,
            default: null
        },
        wish_list_item: {
            type: Boolean,
            default: false
        },
        wish_list: {
            type: Boolean,
            default: false
        },


        product_top: {
            type: Boolean,
            default: false
        },


        description: {},
        gallery3: {
            type: Boolean,
            default: false
        },
        image: {
            type: Boolean,
            default: false
        },
        title: String,
        subtitle: String,
        actionButtons: {
            type: Boolean,
            default: false,
        },
        actionButtonsColor: {
            type: String,
            default: "success",
        },
        codeToggler: {
            type: Boolean,
            default: false,
        },
        noShadow: {
            default: false,
            type: Boolean,
        },
        noRadius: {
            default: false,
            type: Boolean,
        },
        cardBorder: {
            default: false,
            type: Boolean,
        },
        codeLanguage: {
            default: "markup",
            type: String,
        },
        collapseAction: {
            default: false,
            type: Boolean
        },
        refreshContentAction: {
            default: false,
            type: Boolean
        },
        removeCardAction: {
            default: false,
            type: Boolean
        },
        headerBackground: {
            default: '',
            type: String
        },
        // bodyBackground: {
        //   default: '',
        //   type: String
        // },
        // headerbackground: {
        //   default: '',
        //   type: String
        // },
        cardBackground: {
            default: '',
            type: String
        },
        contentColor: {
            default: '',
            type: String
        },
        titleColor: {
            default: '',
            type: String
        },
        subtitleColor: {
            default: '#b8c2cc',
            type: String
        }
    },
    data() {
        return {
            isContentCollapsed: false,
            showCode: false,
            maxHeight: null,
            cardMaxHeight: null,
            codeContainerMaxHeight: '0px',
            tempHidden: false,

            userInfo: window.userInfo,
            showAmount: 0,
            quantity: 1,
            checkout: false,

            sell_type: 1,
            showAmountCash: 0,
            showAmountCredit: 0,

            // Adobe data
            adobe: {
                customers: [],
                calculatedData: false,

                sendData: {
                    product_id: this.product.id,
                    customer_id: 0,
                    quantity: 1,
                    treeYearCommitment: 0,
                }
            }
        }
    },
    watch: {
        quantity(val) {
            this.adobe.sendData.quantity = val;
        },
        'adobe.sendData.customer_id'(val) {
            this.adobe.calculatedData = false;
            this.$emit('customer_id', val);
        },
        'adobe.sendData.quantity'(val) {
            this.adobe.calculatedData = false;
            if (val < 10) this.adobe.sendData.treeYearCommitment = 0;
        },
        'adobe.sendData.treeYearCommitment'(val) {
            this.adobe.calculatedData = false;
        }
    },
    computed: {
        hasAction() {
            return this.$slots.actions || (this.actionButtons || this.collapseAction || this.refreshContentAction || this.codeToggler)
        },
        hasHeader() {
            return this.hasAction || (this.title || this.subtitle)
        },
        StyleItems() {
            return {maxHeight: this.maxHeight}
        },
        cardStyles() {
            let obj = {maxHeight: this.cardMaxHeight}
            if (!_color.isColor(this.cardBackground)) obj.background = _color.getColor(this.cardBackground)
            if (!_color.isColor(this.contentColor)) obj.color = _color.getColor(this.contentColor)
            return obj
        },
        codeContainerStyles() {
            return {maxHeight: this.codeContainerMaxHeight}
        },
        cardClasses() {
            let str = '';

            // Add bg class
            if (_color.isColor(this.cardBackground)) {
                str += ` bg-${this.cardBackground}`
            }

            // add content color
            if (_color.isColor(this.contentColor)) {
                str += ` text-${this.contentColor}`
            }

            return str.trim()
        },
        titleStyles() {
            return {
                color: _color.getColor(this.titleColor)
            }
        },
        titleClasses() {
            let str = '';

            // add content color
            if (_color.isColor(this.titleColor)) {
                str += ` text-${this.titleColor}`
            }

            return str.trim()
        },
        subtitleStyles() {
            let obj = {}
            if (!_color.isColor(this.subtitleColor)) obj.color = _color.getColor(this.subtitleColor)

            return obj
        },
        subtitleClasses() {
            let str = '';

            // add content color
            if (_color.isColor(this.subtitleColor)) {
                str += ` text-${this.subtitleColor}`
            }

            return str.trim()
        },
    },
    created() {
        if (this.product) {
            if (this.userInfo.need_azn_cash) {
                this.showAmountCash = (this.product.cash * this.quantity).toFixed(2);
                this.showAmountCredit = (this.product.credit * this.quantity).toFixed(2);
            } else {
                this.showAmount = (this.product.Amount * this.quantity).toFixed(2);
            }

            if (this.product_top && this.userInfo.type_id === 3 && this.userInfo.has_adobe_account && this.product.provider_id === 3) {
                const thisIns = this;
                this.$vs.loading();
                axios.get(apiUrl + '/getAdobeCustomerList?token=' + token)
                    .then(function (response) {
                        let data = response.data;
                        if (data.code === 200) {
                            thisIns.adobe.customers = data.data;
                            thisIns.$emit('customers', data.data);
                        } else {
                            if (data.code === 401) {
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text: data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        thisIns.$vs.loading.close();
                    });
            }
        }
    },
    methods: {
        getProductPrice(){
            const thisIns = this;
            this.$vs.loading();
            axios.post(apiUrl + '/getAdobeProductPriceByCustomer?token=' + token, this.adobe.sendData)
                .then(function (response) {

                    let data = response.data;
                    if (data.code === 200) {
                        thisIns.adobe.calculatedData = data.data;
                    } else {
                        if (data.code === 401) {
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                    thisIns.$vs.loading.close();
                });
        },
        plus() {
            this.$refs.btnLess.classList.remove("limit");
            this.quantity++;
            this.updateQuantity();
        },
        minus() {
            if (this.quantity === 1) return;
            if (this.quantity === 2) this.$refs.btnLess.classList.add("limit");
            this.quantity--;
            this.updateQuantity();
        },
        changeQuantity(event){
            let value = event.target.value;
            value = parseInt(value.replace(/[^0-9]/g, ''));

            if (Number.isNaN(value)) value = 1;
            if (!Number.isInteger(value)) value = 1;
            if (value < 1) value = 1;

            if(value > 1) this.$refs.btnLess.classList.remove("limit");
            else this.$refs.btnLess.classList.add("limit");

            this.quantity = value;
            this.$refs.quantityInput.value = this.quantity;
            this.updateQuantity();
        },
        updateQuantity() {
            this.showAmount = (this.product.Amount * this.quantity).toFixed(2);
            this.showAmountCash = (this.product.cash * this.quantity).toFixed(2);
            this.showAmountCredit = (this.product.credit * this.quantity).toFixed(2);
        },
        addToBasket() {
            const thisIns = this;
            this.$vs.loading();
            axios.get(apiUrl + '/basket/add/' + this.product.id + '/' + this.quantity + '/' + this.sell_type + '?token=' + token)
                .then(function (response) {

                    let data = response.data;
                    if (data.code === 200) {
                        thisIns.$store.dispatch('basket/reloadData', data.data);
                    } else {
                        if (data.code === 401) {
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                    window.updateMyProfile();
                    thisIns.$vs.loading.close();
                });
        },
        addToBasketAdobeProduct() {
            const thisIns = this;
            this.$vs.loading();
            axios.post(apiUrl + '/basket/add/adobe?token=' + token, this.adobe.sendData)
                .then(function (response) {

                    let data = response.data;
                    if (data.code === 200) {
                        thisIns.$store.dispatch('basket/reloadData', data.data);
                    } else {
                        if (data.code === 401) {
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                    thisIns.$vs.loading.close();
                });
        },
        removeItemFromBasket(item, sell_type = 1) { /* WORK */
            let thisIns = this;
            this.$vs.loading();
            axios.get(apiUrl + '/basket/remove/' + item.id + '/' + sell_type + '?token=' + window.token)
                .then(function (response) {
                    let data = response.data;
                    if (data.code === 200) {
                        thisIns.$store.dispatch('basket/reloadData', data.data);
                        thisIns.quantity--;
                        thisIns.showAmount = (thisIns.item.Amount * thisIns.quantity).toFixed(2);
                    } else if (data.code === 401) {
                        window.logout();
                    }
                    thisIns.$vs.loading.close();
                });

        },

        toggleContent() {
            this.$refs.content.style.overflow = "hidden";
            let scrollHeight = this.$refs.content.scrollHeight
            if (this.maxHeight == '1.5rem') {
                this.maxHeight = `${scrollHeight}px`
                setTimeout(() => {
                    this.maxHeight = 'none';
                    this.$refs.content.style.overflow = "hidden";
                }, 300)
            } else {
                this.maxHeight = `${scrollHeight}px`
                setTimeout(() => {
                    this.maxHeight = `1.5rem`;
                    this.$refs.content.style.overflow = "hidden";
                }, 50)
            }
            this.isContentCollapsed = !this.isContentCollapsed;
            this.$emit("toggleCollapse", this.isContentCollapsed);
        },
        refreshcard() {
            this.$vs.loading({
                container: this.$refs.content,
                scale: 0.5,
            });
            this.tempHidden = true;
            this.$emit("refresh", this);
        },
        removeRefreshAnimation(time = 100) {
            setTimeout(() => {
                this.$vs.loading.close(this.$refs.content)
                this.tempHidden = false;
            }, time)
        },
        removeCard() {
            let scrollHeight = this.$refs.card.scrollHeight
            this.cardMaxHeight = `${scrollHeight}px`
            this.$el.style.overflow = "hidden";
            setTimeout(() => {
                this.cardMaxHeight = `0px`
            }, 50)
            this.$emit("remove");
        },
        toggleCode() {
            this.tempHidden = true;
            this.showCode = !this.showCode;
            let scrollHeight = this.$refs.codeContainer.scrollHeight
            if (this.codeContainerMaxHeight == '0px') {
                this.codeContainerMaxHeight = `${scrollHeight}px`
                setTimeout(() => {
                    this.codeContainerMaxHeight = 'none'
                    this.tempHidden = false;
                }, 300)
            } else {
                this.codeContainerMaxHeight = `${scrollHeight}px`
                setTimeout(() => {
                    this.codeContainerMaxHeight = `0px`
                    this.tempHidden = false;
                }, 150)
            }
        },
    },
    components: {
        Prism,
    },
    mounted() {
        if (this.product) {
            this.showAmount = (this.product.Amount * this.quantity).toFixed(2);
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/components/vxCard.scss";

.flex-bg {
    width: 100%;
    background: #fff;
    border-radius: .5rem;
    display: block;
    -webkit-box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
    position: relative;
    -webkit-transition: all .3s ease-in-out;
    transition: all .3s ease-in-out;
    padding: 45px;
}
</style>
